import React from 'react';
import { motion } from 'framer-motion';
import { Quote, Star } from 'lucide-react';
export function Story() {
  return <section className="py-10 bg-white" data-id="element-424">
      <div className="container mx-auto px-4" data-id="element-425">
        <div className="max-w-4xl mx-auto" data-id="element-426">
          <motion.h2 className="text-3xl md:text-4xl font-bold mb-8 text-center text-blue-600" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-427">
            KARLA Y SU DESCUBRIMIENTO
          </motion.h2>
          <motion.div className="flex flex-col md:flex-row items-center bg-blue-50 rounded-2xl overflow-hidden shadow-lg" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-428">
            <div className="md:w-1/3 relative" data-id="element-429">
              <motion.img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" alt="Karla sonriendo sin dolor de migraña" className="w-full h-full object-cover" whileHover={{
              scale: 1.05
            }} transition={{
              duration: 0.3
            }} data-id="element-430" />
              <motion.div className="absolute top-4 left-4 bg-yellow-400 text-white p-2 rounded-lg shadow-md flex items-center" animate={{
              scale: [1, 1.1, 1]
            }} transition={{
              repeat: Infinity,
              duration: 2
            }} data-id="element-431">
                <Star size={16} fill="currentColor" className="mr-1" data-id="element-432" />
                <span className="font-bold text-sm" data-id="element-433">Historia Real</span>
              </motion.div>
            </div>
            <div className="md:w-2/3 p-8" data-id="element-434">
              <motion.div className="mb-4 text-blue-600" animate={{
              rotate: [0, 5, 0, -5, 0]
            }} transition={{
              repeat: Infinity,
              duration: 5,
              ease: 'easeInOut'
            }} data-id="element-435">
                <Quote size={32} data-id="element-436" />
              </motion.div>
              <p className="text-lg mb-6" data-id="element-437">
                Karla estaba harta de tomar pastillas que la dormían, la
                nublaban o simplemente no hacían nada.
              </p>
              <p className="text-lg mb-6" data-id="element-438">
                <span className="font-bold" data-id="element-439">
                  Buscaba una salida. Algo natural. Algo que funcionara.
                </span>
              </p>
              <p className="text-lg mb-6" data-id="element-440">
                Cuando probó esta rutina terapéutica, su cuerpo respondió. Su
                mente se liberó. Y poco a poco, su energía volvió.
              </p>
              <motion.div className="bg-white p-4 rounded-lg shadow-sm" whileHover={{
              scale: 1.02
            }} data-id="element-441">
                <div className="flex text-yellow-400 mb-2" data-id="element-442">
                  <Star fill="currentColor" size={16} data-id="element-443" />
                  <Star fill="currentColor" size={16} data-id="element-444" />
                  <Star fill="currentColor" size={16} data-id="element-445" />
                  <Star fill="currentColor" size={16} data-id="element-446" />
                  <Star fill="currentColor" size={16} data-id="element-447" />
                </div>
                <p className="text-sm italic" data-id="element-448">
                  "Después de 3 años de migrañas constantes, por fin encontré
                  algo que realmente funciona sin efectos secundarios."
                </p>
                <p className="text-sm font-bold mt-2" data-id="element-449">- Karla M., 34 años</p>
              </motion.div>
              <motion.p className="text-xl font-semibold text-blue-600 mt-6" animate={{
              scale: [1, 1.05, 1]
            }} transition={{
              repeat: Infinity,
              duration: 2
            }} data-id="element-450">
                ✨ Liberarte del dolor también puede ser natural.
              </motion.p>
            </div>
          </motion.div>
          <motion.div className="bg-red-50 p-4 rounded-lg mt-8 border-l-4 border-red-500" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} data-id="element-451">
            <p className="text-red-700 font-medium" data-id="element-452">
              ⚠️ <span className="font-bold" data-id="element-453">ADVERTENCIA:</span> Cada día que
              sigues tomando pastillas, estás potencialmente causando daño a
              largo plazo a tu cuerpo.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}